// extracted by mini-css-extract-plugin
module.exports = {"size":"SizeIcon_size__2jJsv"};